import React from "react";
import ToothFairyPeriodFilter from "../../../../Components/ToothFairyComponents/ToothFairyPeriodFilter";

const DateFilter = ({
  startDate,
  endDate,
  onUpdateStartDate,
  onUpdateEndDate,
  paddingBottom = 5,
}) => {
  return (
    <ToothFairyPeriodFilter
      startDate={startDate}
      endDate={endDate}
      onUpdateStartDate={onUpdateStartDate}
      onUpdateEndDate={onUpdateEndDate}
      paddingBottom={paddingBottom}
    />
  );
};

export default DateFilter;
